
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from '@/views/a-pedidos-ml/pc/lista/controlador';
    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {
        @Prop() public Controlador: ControladorSeccion;
        @Prop() public Item: any;
        @Prop() public Cargando: any;
        public Abierto: boolean = false;

        Seleccionar( item: any )
        {
            this.Controlador.Vista.BarraArriba.Abierto = false;
            item.Accion();
        }
    }
